import React, { createContext, useCallback, useReducer } from 'react';
import {
  InstructionButtonActions,
  InstructionButtonActionTypes,
  InstructionButtonState,
} from './types';
import { defaultState, reducers } from './reducers';

export const InstructionButtonContext = createContext<any>([]);

export const InstructionButtonProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer<
    React.Reducer<InstructionButtonState, InstructionButtonActions>
  >(reducers, defaultState());

  const playInstructions = useCallback(() => {
    if (!state.instructionButtonDisabled) {
      dispatch({
        type: InstructionButtonActionTypes.SET_PLAY_FLAG,
        payload: true,
      });
    }
  }, [dispatch]);
  const stopInstructions = useCallback(() => {
    dispatch({
      type: InstructionButtonActionTypes.SET_PLAY_FLAG,
      payload: false,
    });
  }, [dispatch]);
  const setCurrentInstruction = useCallback(
    (currentInstruction) => {
      dispatch({
        type: InstructionButtonActionTypes.SET_CURRENT_INSTRUCTION,
        payload: currentInstruction,
      });
    },
    [dispatch]
  );
  const setDisabled = useCallback(
    (disabled) => {
      dispatch({
        type: InstructionButtonActionTypes.SET_DISABLED,
        payload: disabled,
      });
    },
    [dispatch]
  );

  return (
    <InstructionButtonContext.Provider
      value={[
        state,
        {
          playInstructions,
          stopInstructions,
          setCurrentInstruction,
          setDisabled,
        },
      ]}
    >
      {children}
    </InstructionButtonContext.Provider>
  );
};

export default InstructionButtonProvider;
